import {AuthorModelV1} from 'resources/GeneratedModels/Author/AuthorModel.v1';
import {userModelExtensions} from 'resources/augmented/User/user.extensions';

AuthorModelV1.extend(userModelExtensions);

export {AuthorModelV1};
